"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _textField = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-field"));

var _axios = _interopRequireDefault(require("axios"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MoveReplyModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(MoveReplyModal, _PureComponent);

  var _super = _createSuper(MoveReplyModal);

  function MoveReplyModal() {
    var _this;

    (0, _classCallCheck2.default)(this, MoveReplyModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "MAIN_THREAD_MOVE", 'Move this reply to the main thread in current topic');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "NEW_TOPIC_MOVE", 'Move this reply to existing topic');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      topic: null,
      isUrlValid: false,
      error: null,
      isMoveToMainThreadSelected: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkUrl", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(topicUrl) {
        var _yield$axios$get, data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!topicUrl || topicUrl.trim() === '')) {
                  _context.next = 3;
                  break;
                }

                _this.setState({
                  topic: null,
                  isUrlValid: false,
                  error: null
                });

                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return _axios.default.get("/topic/checkurl?checkurl=".concat(topicUrl));

              case 6:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;

                _this.setState({
                  topic: data,
                  isUrlValid: true,
                  error: null
                });

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);

                _this.setState({
                  error: 'No topic found for this url, please try something else.',
                  isUrlValid: false,
                  topic: null
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(MoveReplyModal, [{
    key: "renderNewTopicUrlInput",
    value: function renderNewTopicUrlInput() {
      var _this$state$error;

      this.setState({
        isMoveToMainThreadSelected: false
      });
      return (0, _preact.h)(_inputUnit.default, {
        label: "Target topic URL",
        isControl: true,
        error: (_this$state$error = this.state.error) !== null && _this$state$error !== void 0 ? _this$state$error : undefined
      }, (0, _preact.h)(_textField.default, {
        id: "move-to-topic",
        ariaLabel: "move-to-topic",
        name: "move-to-topic",
        isControl: true,
        placeholder: "https://",
        onKeyUp: this.checkUrl,
        type: "text"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onClose = _this$props.onClose,
          isLoading = _this$props.isLoading,
          allowMoveToMainThread = _this$props.allowMoveToMainThread,
          onMoveToTopLevel = _this$props.onMoveToTopLevel,
          onMoveToTopAnotherTopic = _this$props.onMoveToTopAnotherTopic;
      var _this$state = this.state,
          topic = _this$state.topic,
          isUrlValid = _this$state.isUrlValid,
          error = _this$state.error,
          isMoveToMainThreadSelected = _this$state.isMoveToMainThreadSelected;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: "Move reply"
      }), (0, _preact.h)(_modal.ModalBody, null, allowMoveToMainThread ? (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Choose where to move this reply."), (0, _preact.h)(_RadioInputGroup.default, {
        underneath: true,
        options: [this.MAIN_THREAD_MOVE, this.NEW_TOPIC_MOVE],
        onChange: function onChange(option) {
          _this2.setState({
            isMoveToMainThreadSelected: option === _this2.MAIN_THREAD_MOVE
          });
        },
        value: isMoveToMainThreadSelected ? this.MAIN_THREAD_MOVE : this.NEW_TOPIC_MOVE
      }), isMoveToMainThreadSelected ? null : this.renderNewTopicUrlInput()) : this.renderNewTopicUrlInput(), topic && isUrlValid && (0, _preact.h)("div", {
        className: "valid-url-message"
      }, (0, _preact.h)(_inputUnit.default, {
        label: "Topic: ".concat(topic.topictitle),
        isControl: true
      }, (0, _preact.h)("div", null, "You are about to relocate this reply to the topic: ".concat(topic.topictitle, ". The position of your post will be based on the date and time it was originally posted. Are you sure you want to do this?"))))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: "Move",
        variant: "primary",
        onClick: function onClick() {
          if (isMoveToMainThreadSelected) {
            onMoveToTopLevel();
          }

          if (!topic) {
            _this2.setState({
              error: 'Something went wrong'
            });

            return;
          }

          onMoveToTopAnotherTopic(topic.privateId, topic.contenttype, topic === null || topic === void 0 ? void 0 : topic.topictitle);
        },
        isLoading: isLoading,
        disabled: !isMoveToMainThreadSelected && (!isUrlValid || !!error),
        size: "medium",
        "data-qa": "Move"
      })));
    }
  }]);
  return MoveReplyModal;
}(_preactCompat.PureComponent);

var _default = MoveReplyModal;
exports.default = _default;